
import { defineComponent, ref, onMounted } from "vue"
import { Actions } from "@/store/enums/StoreEnums"
import { useStore } from "vuex"
import { useRoute } from "vue-router"
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb"
import { ElMessage } from "element-plus"
import { MatchGameRecord } from "@/store/modules/MatchGameRecordModule"
import { MatchPoolOption } from "@/store/modules/MatchPoolModule"

export default defineComponent({
  setup() {
    const store = useStore()
    const route = useRoute()

    onMounted(() => {
      setCurrentPageBreadcrumbs("游戏记录", ["对对碰系统"])
      loadMatchPools()

      // 如果 URL 带有 match_pool_id 参数，自动填充
      if (route.query.match_pool_id) {
        formData.value.match_pool_id = Number(route.query.match_pool_id)
      }
    })

    const tableData = ref<MatchGameRecord[]>([])
    const matchPoolOptions = ref<MatchPoolOption[]>([])

    const formData = ref({
      match_pool_id: null as number | null,
      user_mobile: '',
      status: ''
    })

    const page = ref({
      currentPage: 1,
      pageSize: 10,
      totalResult: 0,
    })

    const loadMatchPools = async () => {
      try {
        await store.dispatch(Actions.GET_ALL_MATCH_POOLS)
        matchPoolOptions.value = store.getters.currentAllMatchPools
      } catch (error) {
        console.error('加载池子列表失败', error)
      }
    }

    const getMatchCountTagType = (matchCount: number) => {
      if (matchCount === 0) return 'info'
      if (matchCount >= 9) return 'danger'
      if (matchCount >= 5) return 'warning'
      return 'success'
    }

    const query = () => {
      const params: Record<string, unknown> = {
        ...page.value
      }
      if (formData.value.match_pool_id) {
        params.match_pool_id = formData.value.match_pool_id
      }
      if (formData.value.user_mobile) {
        params.user_mobile = formData.value.user_mobile
      }
      if (formData.value.status) {
        params.status = formData.value.status
      }

      store
        .dispatch(Actions.GET_MATCH_GAME_RECORDS, params)
        .then(() => {
          tableData.value = store.getters.currentMatchGameRecordsList
          page.value.totalResult = store.getters.currentMatchGameRecordsCount
        })
        .catch(() => {
          ElMessage.error('获取游戏记录失败')
        })
    }

    query()

    const submitEvent = () => {
      page.value.currentPage = 1
      query()
    }

    const onPageChange = (e: { currentPage: number; pageSize: number }) => {
      page.value.currentPage = e.currentPage
      page.value.pageSize = e.pageSize
      query()
    }

    const onReset = () => {
      formData.value = {
        match_pool_id: null,
        user_mobile: '',
        status: ''
      }
      page.value.currentPage = 1
      query()
    }

    return {
      tableData,
      formData,
      matchPoolOptions,
      submitEvent,
      page,
      onPageChange,
      onReset,
      getMatchCountTagType
    }
  },
})
